import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateChildFn,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { UserStore } from '../stores/user.store';

export const authGuard: CanActivateChildFn = async (
  childRoute: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  const userStore = inject(UserStore);
  const router = inject(Router);
  const user = userStore.user();

  // Auth Guard
  if (!user) {
    try {
      await userStore.fetchUser();
      router.navigate([state.url]);
      return true;
    } catch (error) {
      router.navigate(['/sign-in']);
      return false;
    }
  }

  return true;
};
